import { FetchApi } from '@backstage/core-plugin-api';

export const azureDevOpsFetch = async ({url, token, fetchApi}: {url: string, token: string, fetchApi: FetchApi}) => {
	if (!token) {
		throw new Error('No token provided');
	}

    if (!url) {
        throw new Error('No url provided');
    }

    if (!fetchApi) {
        throw new Error('No fetchApi provided');
    }
    
    const headers: Record<string, string> = {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${token}`,
	};
	const response = await fetchApi.fetch(url, {
		headers,
	});
	return response.json();
};
